export { dedent } from 'ts-dedent';
